export const SHARED_ERROR_AND_WARNING_VALUE_FIELDS = {
  MESSAGE: 'message',
  TYPE: 'type',
};

export const SHARED_ERROR_AND_WARNING_VALUE = {
  [SHARED_ERROR_AND_WARNING_VALUE_FIELDS.MESSAGE]: '',
  [SHARED_ERROR_AND_WARNING_VALUE_FIELDS.TYPE]: undefined,
};
